// extracted by mini-css-extract-plugin
export default {"container":"aezuW6CQECbZKlJesmNu","headline":"Wh8edNv5NUQjzbosbN_H","date":"ry7lnjeOdT37Zi2BDVyz","open":"JdD8o6TlNVV4Uh9RiqRO","list":"tmjccECzHU62LcQbcJ3D"};